import type { StartContent } from './types';

/**
 * Копия лендинга /start (русская).
 *
 * Правишь текст страницы — правишь этот файл, больше ничего. Вёрстка в
 * routes/landing/, числа приходят из API. Источник: макет
 * docs/superpowers/specs/2026-08-14-landings-mockups/landing-pro.html.
 */
export const startRu: StartContent = {
  kind: 'start',
  pageTitle: 'UzTender Pro — контакты заказчиков, документы и цены побед',
  metaDescription:
    'Каталог тендеров Узбекистана — бесплатный. Pro открывает контакты заказчиков, ТЗ и договоры, цены победителей с 2023 года и тендеры Всемирного банка. Новые тендеры приходят в Telegram в день публикации.',
  nav: [
    { label: 'Каталог', href: '/catalog' },
    { label: 'Результаты', href: '/results' },
    { label: 'Цены', href: '/prices' },
    { label: 'МФИ', href: '/ifi' },
  ],
  heroKicker: 'Для компаний, которые уже участвуют в тендерах',
  heroH1: 'Все тендеры Узбекистана — в одном каталоге',
  heroLead:
    'Тендеры публикуются на 35+ разных площадках — мы собираем их все и присылаем подходящее вам в Telegram в день публикации. В Pro: контакты заказчика, ТЗ с договором и цены, по которым выигрывали похожие закупки.',
  // Отступление 10 (ревью владельца): все CTA, кроме кнопок ВНУТРИ блока
  // «Тарифы», ведут на /catalog — площадка продаёт себя сама. ctaPrimary
  // переиспользуется и хиро, и CompareTable (см. types.ts).
  ctaPrimary: 'Перейти к площадке',
  ctaHeader: 'Перейти к площадке',
  // Вторая кнопка хиро больше не «Смотреть каталог бесплатно» — с
  // отступлением 10 primary САМА ведёт в каталог, и повтор стал бы дублем.
  // Repoint: якорь на #pricing, единственное место, которое ещё продаёт тариф.
  ctaSecondary: 'Смотреть тарифы',
  heroMicro: 'Каталог бесплатный, без регистрации. Платите только за инструменты.',
  sourcesLabel: 'Если тендера нет у нас — его нет нигде:',
  sources: [
    'xarid.uzex.uz',
    'etender.uzex.uz',
    'xt-xarid.uz',
    'Всемирный банк',
    'АБР',
    'UNGM',
    'ПРООН',
    'AIIB',
  ],
  // Отступление 7: полоса источников показывала 8 из 16 включённых площадок
  // — поставщик своей площадки в списке не находил и уходил. N считается на
  // сервере (data.sourceCount минус длина sources выше), а не захардкожен.
  sourcesMoreLabel: 'и ещё {count} площадок',
  sourcesUpdateNote: '· обновляем каждые 2 часа',
  counters: {
    activeLabel: 'тендеров открыто сейчас',
    // Отступление 9: счётчик считает последние 7 ПОЛНЫХ календарных дней
    // (UTC), а не один день и не скользящее окно 24ч — published_at хранит
    // только дату, без времени суток, так что скользящее окно и
    // день-к-сегодня оба ломались на этом (см.
    // LandingStatsRepository.counters()). Один день оказался честным, но
    // бесполезным по понедельникам (госзакупки почти не публикуются по
    // выходным) — семь дней сглаживают это, оставаясь тем же принципом:
    // последние ПОЛНЫЕ дни, не текущий незавершённый.
    newLastWeekLabel: 'добавили за неделю',
    // Отступление 1: год истории 2016 → 2023 (до 2023 года в базе 63 строки из 273 380).
    awardedLabel: 'завершённых тендеров с ценой победителя — с 2023 года',
    participantsLabel: 'записей об участниках торгов — видно, кто с кем торгуется',
    ifiLabel: 'тендеров Всемирного банка, АБР и ООН — открыты сейчас',
  },
  // Отступление 11 (2026-08-20): та же пол/потолок база, что и в ip.ru.ts
  // (см. комментарий над factBig там) — только один источник (etender)
  // вообще фиксирует исход «без победителя», остальные хранят лишь победы.
  // «1 из 3» (≈27–33%) — консервативная оценка внутри вилки 21,7% (пол,
  // все источники) / 56–88% (потолок, etender).
  // Перепроверено 2026-08-24 по tender_results: фев–июнь 2026 помесячно
  // 22–35% (n=29 617); июль–август ниже только из-за лага публикации
  // исходов (доля «дозревает» месяцами) — оценка держится.
  // 2026-08-24: по решению владельца бенд развёрнут из одной строки в
  // полноценный конверсионный блок (цифра + заголовок + подводка + CTA).
  factBig: '1 из 3',
  factTitle: 'тендеров закрывается без победителя',
  factBody:
    'Не набралось заявок — заказчик объявляет закупку заново. Кто видит такие лоты первым, торгуется почти без конкурентов.',
  factCta: 'Найти лоты без конкуренции',
  painsTitle: 'Знакомо?',
  pains: [
    {
      title: 'Нашли тендер — а срок уже вышел',
      body: 'Площадок несколько, проверять надо каждый день. Пропустили день — пропустили тендер.',
    },
    {
      title: 'Непонятно, какую цену ставить',
      body: 'Поставили выше — проиграли. Поставили ниже — выиграли, но работаете в ноль.',
    },
    {
      title: 'Контакты заказчика ищете полдня',
      body: 'Через знакомых, через справочники. А хотелось просто позвонить и уточнить пару вопросов.',
    },
  ],
  nicheSectionKicker: 'Проверьте бесплатно — до оплаты',
  nicheSectionTitle: 'Ваша ниша уже в каталоге',
  nicheSectionLead:
    'Живые разделы с активными тендерами прямо сейчас. Откройте свой и посмотрите, что там.',
  moreCategoriesLabel: 'и ещё 22 категории →',
  regionsLabel: 'И все 14 регионов:',
  regions: [
    { code: 'TSH', label: 'город Ташкент' },
    { code: 'TAS', label: 'Ташкентская' },
    { code: 'SAM', label: 'Самаркандская' },
    { code: 'FER', label: 'Ферганская' },
    { code: 'AND', label: 'Андижанская' },
    { code: 'NAM', label: 'Наманганская' },
    { code: 'BUK', label: 'Бухарская' },
    { code: 'KAS', label: 'Кашкадарьинская' },
    { code: 'SUR', label: 'Сурхандарьинская' },
    { code: 'KHO', label: 'Хорезмская' },
    { code: 'NAV', label: 'Навоийская' },
    { code: 'JIZ', label: 'Джизакская' },
    { code: 'SIR', label: 'Сырдарьинская' },
    { code: 'KAR', label: 'Каракалпакстан' },
  ],
  howKicker: 'Как это работает',
  howTitle: 'Что меняет Pro',
  how: [
    {
      title: 'Тендеры приходят сами',
      body: 'Сохраните поиск — например, «стройка, Наманган». Новые тендеры придут в Telegram в день публикации. По утрам — один дайджест со всем новым по вашим темам.',
      bullets: [
        'Уведомления по вашим поискам — без ограничений',
        'Бот отвечает на вопросы по ТЗ',
        'Сервис видит, какие тендеры вы выигрывали, и сам присылает похожие',
      ],
      // Снимок Pro-кабинета 13.08.2026 (мокап landing-pro.html:419–425).
      illustration: {
        kind: 'chat',
        messages: [
          {
            side: 'in',
            title: '🔔 Новый тендер по поиску «стройка, Наманган»',
            body: 'Капремонт здания Госпалаты кадастра — 2,2 млрд сум, подача до 20 августа',
            time: '08:12',
          },
          { side: 'out', title: '', body: 'какие требования к опыту?', time: '' },
          {
            side: 'in',
            title: 'UzTender',
            body: 'По ТЗ: опыт похожих работ, лицензия на строительно-монтажные работы, обеспечение 22,07 млн сум',
            time: '08:13',
          },
        ],
      },
      links: [],
    },
    {
      title: 'Видно, по каким ценам выигрывают',
      // Отступление 1: год истории 2016 → 2023.
      body: 'У каждого тендера — рыночные данные: сколько обычно приходит участников и в каком диапазоне побеждали похожие закупки. Это не прогноз, а история реальных торгов с 2023 года.',
      bullets: [
        'Цены победителей по вашей категории',
        'Сколько участников обычно приходит на такие торги',
        'У кого заказчик уже покупает — и как часто',
      ],
      // Реальные цифры из Pro-кабинета: тендер «Юридические услуги», 13.08.2026
      // (мокап landing-pro.html:443–453).
      illustration: {
        kind: 'stats',
        title: 'Поставщики этого заказчика',
        badge: 'из Pro-кабинета',
        source: '5 поставщиков · 5 контрактов · 75,3 млн сум',
        rows: [
          { label: 'Постоянный поставщик', value: '51,1% контрактов', strong: true },
          { label: 'Второй по объёму', value: '29,0%', strong: false },
          { label: 'Остальные', value: '19,9%', strong: false },
        ],
        note: 'Если у заказчика один «свой» поставщик — вы узнаете это до подачи, а не после проигрыша.',
      },
      // Две ссылки под чек-листом (мокап landing-pro.html:438–441) — единственные
      // контекстные внутренние ссылки на /results и /prices с этой страницы.
      links: [
        { label: 'Результаты тендеров →', href: '/results' },
        { label: 'Средние цены →', href: '/prices' },
      ],
    },
    {
      title: 'Заказчику можно позвонить',
      body: 'До подачи, а не после. Открыли тендер — там контакты заказчика, ТЗ и договор. Один звонок снимает половину вопросов и экономит неделю переделок.',
      bullets: [
        'Контакты заказчиков — без ограничений',
        'ТЗ и договор — сразу в карточке тендера',
        'Выгрузка в Excel — для сметчика и планёрки',
      ],
      // Реальный тендер: документы и контакт как в Pro-кабинете
      // (мокап landing-pro.html:467–489). ИНН заказчика намеренно усечён —
      // это платный контакт, иллюстрация не должна его раскрывать.
      illustration: {
        kind: 'docs',
        status: 'Активен',
        left: 'осталось 8 дней',
        title: 'Прочие юридические услуги — управление госимуществом в Самарканде',
        categories: ['Финансовые и юридические услуги'],
        rows: [
          { label: 'Бюджет', value: '63,6 млн сум' },
          { label: 'Контактное лицо', value: 'Агентство по управлению госактивами · ИНН 2016…' },
        ],
        docs: ['Texniktopshiriq.pdf', 'Шартнома(ГПД).pdf'],
        steps: ['Увидели тендер', 'Открыли ТЗ', 'Позвонили', 'Подали заявку'],
      },
      links: [],
    },
  ],
  // Панель «Рыночные данные» из хиро (мокап landing-pro.html:304–316) —
  // снимок Pro-кабинета того же тендера, что и карточка выше, 13.08.2026.
  heroIllustration: {
    kind: 'range',
    title: 'Рыночные данные',
    badge: 'из Pro-кабинета',
    source: 'На основе 500 похожих результатов',
    cells: [
      { label: 'Медиана участников', value: '5' },
      { label: 'Медианная скидка', value: '5%' },
    ],
    rangeLabel: 'Диапазон цены победителя',
    min: '441,7 млн',
    max: '3,9 млрд',
    markerPct: 51,
    note: 'этот тендер — 2,2 млрд',
  },
  heroSearchPlaceholder: 'Поиск тендеров по смыслу…',
  compareTitle: 'Что бесплатно, а что в Pro',
  compareLead:
    'Каталог был и останется бесплатным. Pro — это то, что сверху: инструменты для участия.',
  compareHeadFree: 'Бесплатно',
  compareHeadPro: 'Pro',
  compareGroups: [
    {
      title: 'Бесплатно — всем и навсегда',
      rows: [
        { label: 'Все тендеры: суммы, сроки, обеспечение', free: '✓', pro: '✓' },
        { label: 'Понятное описание на русском и узбекском', free: '✓', pro: '✓' },
        { label: 'Средние цены по категориям', free: '✓', pro: '✓' },
      ],
    },
    {
      title: 'Открывается в Pro',
      rows: [
        { label: 'Контакты заказчиков', free: '—', pro: 'без лимита' },
        { label: 'ТЗ и договор по каждому тендеру', free: '—', pro: '✓' },
        { label: 'Кто выиграл похожие тендеры и по какой цене', free: '—', pro: '✓' },
        { label: 'Сколько участников приходит и у кого заказчик покупает', free: '—', pro: '✓' },
        { label: 'Тендеры Всемирного банка, АБР и ООН', free: '—', pro: '✓' },
        { label: 'Telegram-бот: уведомления, дайджесты, ответы по ТЗ', free: '—', pro: '✓' },
        { label: 'Сохранённые поиски и уведомления — без ограничений', free: '—', pro: '✓' },
        { label: 'Выгрузка в Excel', free: '—', pro: '✓' },
      ],
    },
  ],
  ifiKicker: 'Для растущих компаний',
  ifiTitle: 'Тендеры Всемирного банка, АБР и ООН',
  // Отступление 9-подобное: число берётся из data.ifiActive, а не захардкожено
  // ({count}/{word} подставляет страница) — иначе цифра расходится со счётчиком
  // выше при первом же изменении каталога (см. search.empty.title в i18n/locales/ru.ts).
  ifiBody:
    '{count} открытых международных {word}. Заказчики — узбекские ведомства, деньги — банков и фондов, бюджеты в валюте. И конкурентов здесь заметно меньше, чем на биржевых площадках.',
  ifiCta: 'Открыть раздел МФИ →',
  // Карточка тендера МФИ (мокап landing-pro.html:540–549).
  ifiIllustration: {
    kind: 'docs',
    status: 'Активен',
    left: 'осталось 16 дней',
    title: 'Укрепление систем управления пастбищами в Узбекистане',
    categories: ['Научные исследования', 'МФИ'],
    rows: [
      { label: 'Финансирование', value: 'Всемирный банк' },
      { label: 'Закрытие', value: '28 августа 2026' },
    ],
    docs: [],
    steps: [],
  },
  pricingTitle: 'Тарифы',
  pricingLead:
    'Читать и разбирать тендеры можно бесплатно. Тариф открывает контакты заказчиков, документы и аналитику.',
  periodMonthly: 'Месяц',
  periodYearly: 'Год',
  periodYearlyBadge: '×2 выгода',
  // Отступление 11 (2026-08-20): тариф ИП убран из plans[] целиком — /start
  // продаёт Pro и Бизнес, у ИП своя страница /ip. `ipCrossLinkText`/Label
  // ниже остаются (это единственный переход на /ip) — PricingThree теперь
  // печатает их под сеткой тарифов, а не под конкретной карточкой (см.
  // sections/pricing-three.tsx).
  plans: [
    {
      name: 'Pro',
      priceMonthly: '399 000 сум/мес',
      priceYearly: '2 399 000 сум/год',
      wasYearly: '4 788 000',
      noteMonthly: 'или 2 399 000 сум/год — год за цену 6 месяцев',
      noteYearly: 'год за цену 6 месяцев — экономия 2 389 000 сум',
      features: [
        'Все контакты заказчиков — без лимита',
        'ТЗ и договор по каждому тендеру',
        'Аналитика: цены побед и участники',
        'Тендеры Всемирного банка, АБР и ООН',
        'Telegram-бот: уведомления, дайджесты, ответы по ТЗ',
        'Уведомления по вашим выигранным тендерам — настраиваются сами',
        'Выгрузка в Excel',
      ],
      yearlyOnlyFeatures: ['Приоритетная поддержка — в годовой подписке'],
      cta: 'Оформить Pro',
      highlighted: true,
      flag: 'Популярный',
      note: null,
    },
    {
      name: 'Бизнес',
      priceMonthly: '699 000 сум/мес',
      priceYearly: '4 199 000 сум/год',
      wasYearly: null,
      noteMonthly: 'или 4 199 000 сум/год',
      noteYearly: 'при оплате за год — ×2 выгода',
      features: [
        'Всё из Pro',
        '3 места: вы и сотрудники',
        'У каждого — свой бот и свои уведомления',
      ],
      yearlyOnlyFeatures: [],
      cta: 'Оформить Бизнес',
      highlighted: false,
      flag: null,
      note: 'Для команд: снабженец следит за тендерами, сметчик считает по ценам побед, директор видит всю картину.',
    },
  ],
  // ipCrossLinkLabel — человекочитаемая форма домена, как на макете (это подпись
  // ссылки, а не href; сам переход на bare-путь `/ip` собирает компонент).
  ipCrossLinkText: 'Только начинаете? Для вас отдельная страница:',
  ipCrossLinkLabel: 'uztender.com/ip',
  payNote:
    'Оплата через Payme или по счёту (для юрлиц и ИП — за год). Отмена в любой момент: доступ работает до конца оплаченного срока.',
  teamTitle: 'Кто за этим стоит',
  // Отступление 4: команда — две карточки (CEO + CTO), без официоза —
  // фото крупнее (мокап landing-pro.html:617–644, #trust). Отступление 6
  // (ревью владельца, 2026-08-18): убрали проброс-абзац `bio` целиком — читался
  // как автогенерированный текст; карточка теперь только фото + имя + роль.
  // «Кто мы» (юрлицо, город) — в чипах `fineprint` ниже.
  team: [
    {
      name: 'Игорь Ким',
      role: 'CEO',
      photo: '/img/team/igor.jpg',
      initials: 'ИК',
      links: [
        { label: 'Написать в Telegram', href: 'https://t.me/flesteyto', primary: true },
        { label: 'support@uztender.com', href: 'mailto:support@uztender.com', primary: false },
      ],
    },
    {
      name: 'Константин Цой',
      role: 'CTO',
      photo: '/img/team/konstantin.jpg',
      initials: 'КЦ',
      links: [],
    },
  ],
  // Отступление 5: «Резидент IT Park» не публикуем — формулировка не подтверждена.
  fineprint: [
    { label: 'ООО «FASTAGO»', href: null },
    { label: 'ИНН 306377222', href: null },
    { label: 'Ташкент', href: null },
    { label: 'Полные реквизиты →', href: '/requisites' },
  ],
  faqTitle: 'Частые вопросы',
  faq: [
    {
      q: 'Каталог бесплатный — за что тогда платить?',
      a: 'Каталог показывает, что тендер есть. Pro даёт то, чем его выигрывают: контакты заказчика, ТЗ с договором, цены победителей и уведомления, чтобы узнавать о новых тендерах первым.',
    },
    {
      q: 'Какие площадки вы собираете?',
      a: 'Официальные площадки Узбекистана — xarid.uzex.uz, etender.uzex.uz, xt-xarid.uz и другие. Плюс тендеры Всемирного банка, АБР, UNGM, ПРООН и AIIB. Каталог обновляется каждые 2 часа.',
    },
    {
      q: 'Кому нужен Бизнес?',
      a: 'Командам от двух человек. В Бизнесе 3 места, у каждого — свой бот и свои уведомления: снабженец, сметчик и директор работают параллельно.',
    },
    {
      q: 'Что даёт годовая подписка?',
      a: 'Год за цену шести месяцев: Pro — 2 399 000 сум вместо 4 788 000. Плюс приоритетная поддержка. Юрлица и ИП могут оплатить по счёту.',
    },
    {
      q: 'А если в моей нише мало тендеров?',
      a: 'Проверьте до оплаты — каталог открыт: 31 категория, все 14 регионов. Не нашли своё — напишите нам, посмотрим вместе.',
    },
    {
      q: 'Как отменить подписку?',
      a: 'В любой момент, в пару кликов в личном кабинете. Доступ работает до конца оплаченного срока, дальше деньги не списываются.',
    },
  ],
  // Отступление 9: «Сегодня» → «за неделю» ({count} и согласованное {word}
  // подставляет страница — см. tendersWord в lib/format.ts).
  finalH2: 'За неделю в каталог добавили {count} {word}',
  finalLead:
    'Завтра будут новые. Вопрос один: узнаете вы о них в день публикации — или когда срок уже выйдет.',
  finalCtaPrimary: 'Перейти к площадке',
  footerLinks: [
    { label: 'О сервисе', href: '/about' },
    { label: 'Гид для поставщиков', href: '/guide' },
    { label: 'Тарифы', href: '/plans' },
    { label: 'Публичная оферта', href: '/offer' },
    { label: 'Конфиденциальность', href: '/privacy' },
    { label: 'Реквизиты', href: '/requisites' },
    { label: '@flesteyto', href: 'https://t.me/flesteyto' },
    { label: '+998 90 187-77-98', href: 'tel:+998901877798' },
  ],
  footerLegal: '© 2026 ООО «FASTAGO». Все права защищены. ИНН: 306377222',
  stickyTitle: 'Pro — 399 000 сум/мес',
  stickySubtitle: 'каталог — бесплатно',
  stickyCta: 'Перейти к площадке',
};
